import React from 'react';
import { styled } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import { token } from '@atlaskit/tokens';

import RestrictedContentIcon from './RestrictedContentIcon.svg';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const RestrictedPageContainer = styled.div({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const RestrictedPageContentWrapper = styled.div({
	width: '624px',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	height: '95vh',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CenteredContent = styled.div({
	textAlign: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const RestrictedMessageTitle = styled.h2({
	margin: `${token('space.250')} 0`,
	fontWeight: token('font.weight.medium'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const RestrictedContentImage = styled.img({
	width: '150px',
	margin: '0 auto',
});

export const RestrictedPage = (): React.JSX.Element => (
	<RestrictedPageContainer>
		<RestrictedPageContentWrapper>
			<CenteredContent>
				<RestrictedContentImage src={RestrictedContentIcon} />
				<RestrictedMessageTitle>
					<FormattedMessage
						id="site-permissions.restricted.page.view.title"
						description="Title displayed for a page that has viewing restricted"
						defaultMessage="This is a restricted page"
					/>
				</RestrictedMessageTitle>
				<FormattedMessage
					id="site-permissions.restricted.page.manual.request.access.from.author"
					description="Instructions to manually request access to a restricted page from the page's author"
					defaultMessage="If you think you should have access, try asking the person who sent you here for help."
				/>
			</CenteredContent>
		</RestrictedPageContentWrapper>
	</RestrictedPageContainer>
);
